export const JSON_ONE1 = {
   
  
    
        "me_id": "040721140456",
        "acc_creation_datetime": "Sep 22, 2021 12:38:05 PM",
        "status": "Active",
        "status_code": "0",
        "description": "Virtual Account Number Created successfully!",
        "bene_IFSC_Code": "YESB0CMSNOC",
        "bene_Bank_name": "Yes Bank",
        "bene_name": "NIKE NEW AWS",
        "me_order_id": "ssds323asSDd3333",
        "ag_order_id": "49298951",
        "udf_1": "123",
        "udf_2": "1SD23"
        }

